import { ClarionSpinner } from '@clarion/ClarionSpinner';
import NonIdealPage from '../util/NonIdealPage';

export default function EmbedLoadingScreen() {
  return <NonIdealPage title="Loading your content…" description={<ClarionSpinner size={30} />} />;
}
